<template>
	<div class="dropdown no-arrow">
    	<button
    		class="dropdown-toggle btn btn-link"
    		role="button"
    		ref="dropDown"
    		data-toggle="dropdown"
    		aria-haspopup="true"
    		aria-expanded="false">
      		<i class="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
    	</button>
    	<div
    		class="dropdown-menu dropdown-menu-right shadow animated--fade-in"
    		aria-labelledby="dropDown">
      		<div class="dropdown-header" v-if="dropdownHeader">{{ dropdownHeader }}</div>
      		<button
				v-for="tab in tabs"
				class="dropdown-item"
				:ref="tab.field"
				@click="nav_change(tab.field)">
				{{ tab.label }}
			</button>
    	</div>
    </div>
</template>

<script>
	export default {
		props: {
			dropdownHeader: {
				type: String
			},
	        tabs: {
	            type: Array
	        },
	        ativo: {
	        	type: Number
	        }
	    },
		mounted(){
			let index = 0;
			if(this.ativo){
				index = this.ativo;
			}
			if(!$(this.$refs[this.tabs[index]['field']]).hasClass('active')){
                var el = this.$refs[this.tabs[index]['field']][0]
				el.classList.add("active");
			}
		},

		methods: {
			nav_change(tab){
				for (var i=0; i<this.tabs.length; i++) {
					if($(this.$refs[this.tabs[i]['field']]).hasClass('active')){
                        var el = this.$refs[this.tabs[i]['field']][0]
						el.classList.remove("active");
					}
				}

				if($(this.$refs[tab]).hasClass('active')){
					this.$refs[tab].classList.remove("active");
				}

				var el = this.$refs[tab][0]
				el.classList.add("active");

				this.$emit('navChanged', tab);
			}
		}
	}
</script>

<style scoped>
	#bsh-tab button {
		background-color: white;
	}
	.cl-blue {
		color: blue;
	}
	.nowrap {
		white-space:nowrap;
	}
	.dropdown-toggle::after {
    	display:none;
	}
</style>
